import { AdditiveBlending, Color, DoubleSide, RawShaderMaterial } from 'three'
import VS from './shaders/simple-vs.glsl'
import FS from './shaders/reveal-bg-fs.glsl'
export default {
  getMaterial() {
    const material = new RawShaderMaterial({
      transparent: true,
      uniforms: {
        time: { value: Math.random() * 100 },
        color: { value: new Color(0xf3dfa5) },
        opacity: { value: 1 },
        randomFactor: { value: Math.random() }
      },
      side: DoubleSide,
      depthTest: true,
      depthWrite: false,
      vertexShader: VS,
      fragmentShader: FS,
      blending: AdditiveBlending
    })

    return material
  }
}
